import React, { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Boundary de code-split para o modal do card.
 * O conteúdo pesado permanece em KanbanPageSimple até extração completa das abas.
 */
const KanbanCardModalContent = lazy(() =>
  import('./KanbanCardModalContent').then((m) => ({ default: m.KanbanCardModalContent }))
);

export type KanbanCardModalLazyProps = React.ComponentProps<typeof KanbanCardModalContent>;

export function KanbanCardModalLazy(props: KanbanCardModalLazyProps) {
  if (!props.isOpen) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <Loader2 className="h-8 w-8 animate-spin text-white" />
        </div>
      }
    >
      <KanbanCardModalContent {...props} />
    </Suspense>
  );
}
